import { useUIStore } from '@/state/uiStore';
import css from './ThemeToggle.module.css';

export function ThemeToggle() {
  const theme = useUIStore((s) => s.theme);
  const toggle = useUIStore((s) => s.toggleTheme);
  const next = theme === 'light' ? 'dark' : 'light';

  return (
    <button
      className={css.toggle}
      type="button"
      onClick={toggle}
      aria-label={`Switch to ${next} mode`}
      aria-pressed={theme === 'dark'}
    >
      {theme === 'dark' ? '☀️' : '🌙'} {theme === 'dark' ? 'Light' : 'Dark'}
    </button>
  );
}
